// extracted by mini-css-extract-plugin
module.exports = {"text":"FeedbackSnippet_text__34Qs4","radio":"FeedbackSnippet_radio__2fNmf"};